import { render, staticRenderFns } from "./AgreementsCounterpartyPage.vue?vue&type=template&id=fad87446"
import script from "./AgreementsCounterpartyPage.vue?vue&type=script&lang=js"
export * from "./AgreementsCounterpartyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports